export default class WebWorker {
	constructor(worker) {
		const code = worker.toString();
		const blob = new Blob(['('+code+')()']);
		this.urlObj = URL.createObjectURL(blob)
		this.worker = new Worker(this.urlObj);
	}

	revoke = () => {
		URL.revokeObjectURL(this.urlObj)
	}
}